"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bell = function Bell(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M12 19C12.5304 19 13.0391 18.7893 13.4142 18.4142C13.7893 18.0391 14 17.5304 14 17H10C10 17.5304 10.2107 18.0391 10.5858 18.4142C10.9609 18.7893 11.4696 19 12 19Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16.5 15.0001V12.0001C16.5 9.98026 15.1623 8.26706 13.3263 7.69968C13.4471 7.47109 13.5067 7.21517 13.4994 6.95674C13.4921 6.69832 13.4182 6.44616 13.2847 6.22474C13.1513 6.00332 12.9629 5.82015 12.7378 5.69299C12.5127 5.56584 12.2585 5.49902 12 5.49902C11.7415 5.49902 11.4873 5.56584 11.2622 5.69299C11.0371 5.82015 10.8487 6.00332 10.7153 6.22474C10.5818 6.44616 10.5079 6.69832 10.5006 6.95674C10.4933 7.21517 10.5529 7.47109 10.6737 7.69968C8.83772 8.26706 7.5 9.98026 7.5 12.0001V15.0001C7.23478 15.0001 6.98043 15.1055 6.79289 15.293C6.60536 15.4805 6.5 15.7349 6.5 16.0001C6.5 16.2653 6.60536 16.5197 6.79289 16.7072C6.98043 16.8948 7.23478 17.0001 7.5 17.0001H16.5C16.7652 17.0001 17.0196 16.8948 17.2071 16.7072C17.3946 16.5197 17.5 16.2653 17.5 16.0001C17.5 15.7349 17.3946 15.4805 17.2071 15.293C17.0196 15.1055 16.7652 15.0001 16.5 15.0001ZM12 6.50012C12.0989 6.50012 12.1956 6.52944 12.2778 6.58439C12.36 6.63933 12.4241 6.71742 12.4619 6.80878C12.4998 6.90014 12.5097 7.00067 12.4904 7.09767C12.4711 7.19466 12.4235 7.28375 12.3536 7.35367C12.2836 7.4236 12.1945 7.47122 12.0975 7.49051C12.0006 7.50981 11.9 7.4999 11.8087 7.46206C11.7173 7.42422 11.6392 7.36013 11.5843 7.27791C11.5293 7.19568 11.5 7.09901 11.5 7.00012C11.5002 6.86756 11.5529 6.74047 11.6466 6.64674C11.7404 6.553 11.8674 6.50027 12 6.50012Z",
    fill: props.foregroundColor
  }));
};

Bell.defaultProps = {
  altText: "Bell",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Bell.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Bell;
exports.default = _default;